module.exports = __webpack_public_path__ + "img/d8.dade6741.png";